import { useState as c } from "react";
var i = function(e) {
  var a = c(function() {
    try {
      var r = localStorage.getItem(e);
      return r ? JSON.parse(r) : null;
    } catch {
      return null;
    }
  }), n = a[0], u = a[1], l = function(r) {
    try {
      var t = r;
      return u(t), localStorage.setItem(e, JSON.stringify(t)), t;
    } catch {
      return null;
    }
  }, o = function() {
    try {
      localStorage.removeItem(e);
    } catch {
      return;
    }
  };
  return {
    storedValue: n,
    setValue: l,
    removeValue: o
  };
};
export {
  i as useLocalStorage
};
//# sourceMappingURL=useLocalStorage.es.js.map
